module.exports = __webpack_public_path__ + "img/purchase-icon-active.d3214c7b.svg";